import { get_first_defined_value } from './service_layer_agreement.helpers';
export {
  format_duration_value,
  parse_duration_input_value,
} from './service_layer_agreement.form_helpers';

function get_sla_workflow_id(item = {}) {
  const workflow_value = get_first_defined_value([
    item.workflow_id,
    item.entity_type_workflow,
    item.entity_type_workflow_id,
    item.sla_workflow_id,
    item.workflow,
    item.sla_workflow,
    0,
  ]);
  const workflow_id = Number(workflow_value) || null;
  return workflow_id;
}

function get_sla_workflow_name(item = {}) {
  const workflow_name = String(get_first_defined_value([
    item.workflow_name,
    item.entity_type_workflow_name,
    item.workflow?.name,
    item.entity_type_workflow?.name,
    '',
  ])).trim();
  return workflow_name;
}

function get_status_metadata(is_active) {
  const status_metadata = is_active
    ? { status_label: 'Active', status_class: 'sla-status-active' }
    : { status_label: 'Inactive', status_class: 'sla-status-inactive' };
  return status_metadata;
}

function build_duration_labels(item = {}, vm) {
  const duration_labels = {
    target_duration_label: vm.format_duration(item.target_duration),
    warning_threshold_label: vm.format_duration(item.warning_threshold),
    escalation_duration_label: vm.format_duration(item.escalation_duration),
  };
  return duration_labels;
}

function build_workflow_label(workflow_name, workflow_id) {
  const workflow_label = workflow_name || (workflow_id ? `Workflow ${workflow_id}` : 'No workflow');
  return workflow_label;
}

function get_sla_project_id(item = {}) {
  const project_id = get_first_defined_value([
    item.project,
    item.project_id,
    null,
  ]);
  return project_id;
}

function get_sla_name(item = {}) {
  const default_name = item.id ? `SLA ${item.id}` : '';
  const name = item.name || default_name;
  return name;
}

function get_sla_duration_value(item = {}, key) {
  const duration_value = Reflect.get(item, key) || '-';
  return duration_value;
}

function build_base_sla_item(item = {}, workflow_id, workflow_name) {
  const base_item = {
    id: item.id,
    name: get_sla_name(item),
    description: item.description || '',
    target_duration: get_sla_duration_value(item, 'target_duration'),
    warning_threshold: get_sla_duration_value(item, 'warning_threshold'),
    escalation_duration: get_sla_duration_value(item, 'escalation_duration'),
    project_id: get_sla_project_id(item),
    workflow_id,
    workflow_name,
    workflow_label: build_workflow_label(workflow_name, workflow_id),
  };
  return base_item;
}

function build_sla_metadata(item = {}, vm, is_active) {
  const metadata = {
    is_active,
    created_label: vm.format_date(item.date_created || item.date_updated),
  };
  return metadata;
}

export function build_normalized_sla_item(item = {}, vm) {
  const is_active = item.is_active !== false;
  const workflow_id = get_sla_workflow_id(item);
  const workflow_name = get_sla_workflow_name(item);
  const status_metadata = get_status_metadata(is_active);
  const base_item = build_base_sla_item(item, workflow_id, workflow_name);
  const duration_labels = build_duration_labels(item, vm);
  const sla_metadata = build_sla_metadata(item, vm, is_active);
  const normalized_item = {
    ...base_item,
    ...duration_labels,
    ...sla_metadata,
    ...status_metadata,
  };
  return normalized_item;
}

export function format_date_value(date_value) {
  if (!date_value) {
    const empty_value = '-';
    return empty_value;
  }
  const date = new Date(date_value);
  if (Number.isNaN(date.getTime())) {
    const invalid_value = '-';
    return invalid_value;
  }
  const formatted_value = date.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
  return formatted_value;
}
